(function () {
  'use strict';
  function money(cents, tpl) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var loc = document.documentElement.lang || 'en';
    try {
      var v = cents / 100;
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function init(root) {
    if (root.__lx) return; root.__lx = true;
    var jsonEl = root.querySelector('[data-lx-product-json]') || document.querySelector('[data-lx-product-json]');
    if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var info = root.querySelector('product-info') || root;
    var select = info.querySelector('select[data-size-native]');
    var priceNow = info.querySelector('.section-product__price-current');
    var priceCmp = info.querySelector('.section-product__price-compare');
    var priceSave = info.querySelector('.section-product__save');
    var priceRow = info.querySelector('.section-product__price');
    function variantFor(value) {
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].option1 === value) return product.variants[i];
      return product.variants[0];
    }
    function idInputs() { return Array.prototype.slice.call(document.querySelectorAll('product-form-component input[name="id"]')); }
    function atcButtons() { return Array.prototype.slice.call(root.querySelectorAll('.lx-atc button[type="submit"], .lx-atc add-to-cart-component button')); }
    function apply(v) {
      if (!v) return;
      idInputs().forEach(function (i) { i.value = v.id; });
      if (priceNow) priceNow.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceCmp) { priceCmp.textContent = onSale ? money(v.compare_at_price) : ''; priceCmp.hidden = !onSale; }
      if (priceSave) { priceSave.textContent = onSale ? 'SAVE ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; priceSave.hidden = !onSale; }
      atcButtons().forEach(function (b) {
        if (v.available) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); b.dataset.lxSoldOut = ''; }
        else { b.setAttribute('disabled', ''); b.setAttribute('aria-disabled', 'true'); b.dataset.lxSoldOut = '1'; }
      });
      var sel = info.querySelector('script[data-selected-variant]');
      if (sel) sel.textContent = JSON.stringify(v);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    }
    if (select) {
      select.addEventListener('change', function () { apply(variantFor(select.value)); });
      apply(variantFor(select.value));
    }
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-sticky-size-card]');
      if (c && select) { select.value = c.getAttribute('data-value'); select.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function boot() { document.querySelectorAll('.luxevyn-scope').forEach(function (r) { if (r.querySelector('[data-lx-product-json]')) init(r); }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ===== Add-to-cart feedback: loading -> added state, fly-to-bag, drawer open ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = null, safety = null;

  function isAtc(el) {
    return el && el.closest && el.closest('.lx-atc button[type="submit"], .sticky-cart__submit, button.add-to-cart-button');
  }
  function setState(btn, state) {
    if (!btn) return;
    if (state) btn.setAttribute('data-lx-state', state); else btn.removeAttribute('data-lx-state');
  }
  function bagTarget() {
    return document.querySelector('.lxh__cart svg') || document.querySelector('[data-lx-cart]') || document.querySelector('cart-icon');
  }
  function fly(fromEl) {
    if (reduce || !fromEl || !fromEl.animate) return;
    var to = bagTarget(); if (!to) return;
    var a = fromEl.getBoundingClientRect(), b = to.getBoundingClientRect();
    var dot = document.createElement('div');
    dot.setAttribute('aria-hidden', 'true');
    dot.innerHTML = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M4.2 7.2h13.6l-1 11.6H5.2l-1-11.6Z" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"/><path d="M8 7.2V6.4a3 3 0 0 1 6 0v.8" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';
    var s = dot.style;
    s.cssText = 'position:fixed;z-index:2147483000;left:0;top:0;width:44px;height:44px;border-radius:50%;background:#12b76a;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(18,183,106,.45);pointer-events:none;will-change:transform,opacity';
    document.body.appendChild(dot);
    var sx = a.left + a.width / 2 - 22, sy = a.top + a.height / 2 - 22;
    var ex = b.left + b.width / 2 - 22, ey = b.top + b.height / 2 - 22;
    var mx = (sx + ex) / 2, my = Math.min(sy, ey) - 90;
    var anim = dot.animate([
      { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(.6)', opacity: 0 },
      { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1.1)', opacity: 1, offset: .12 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(1)', opacity: 1, offset: .55 },
      { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.35)', opacity: .9 }
    ], { duration: 780, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
    anim.onfinish = function () { dot.remove(); };
  }
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
  }
  function done(btn, ok) {
    clearTimeout(safety);
    if (!btn) return;
    if (ok) {
      setState(btn, 'added');
      fly(btn);
      if (typeof window.lxHeaderBump === 'function') window.lxHeaderBump();
      setTimeout(openDrawer, reduce ? 0 : 650);
      setTimeout(function () { if (btn.getAttribute('data-lx-state') === 'added') setState(btn, ''); }, 2200);
    } else {
      setState(btn, 'error');
      setTimeout(function () { setState(btn, ''); }, 1800);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = isAtc(e.target);
    if (!btn || btn.disabled) return;
    var b = btn.tagName === 'BUTTON' ? btn : btn.closest('button');
    pending = b; setState(b, 'adding');
    clearTimeout(safety);
    safety = setTimeout(function () { if (pending === b && b.getAttribute('data-lx-state') === 'adding') { setState(b, ''); } }, 9000);
  }, true);

  document.addEventListener('shopify:cart:lines-update', function (ev) {
    if (ev.action && ev.action !== 'add') return;
    var b = pending; pending = null;
    if (!ev.promise || !ev.promise.then) { done(b, true); return; }
    ev.promise.then(function (r) { done(b, !(r && r.detail && r.detail.didError)); }).catch(function () { done(b, false); });
  });
  document.addEventListener('shopify:cart:error', function () { var b = pending; pending = null; done(b, false); });
})();
